import { stripHtml } from '@/utils';

export default {
  methods: {
    getQuestion(state) {
      return this.allFlashcards?.find(q => q.id === state.flashcardId);
    },
    getQuestionText(state, question) {
      if (!question) return '';

      const questionType = question.type;
      const rawQuestion = question.question;
      let questionText = stripHtml(rawQuestion);

      if (questionType === 'Cloze / Dropdown') {
        const matches = questionText.match(/\{\{[^\}]+\}\}/g);
        if (matches) {
          matches.forEach((match) => {
            const identifier = match.replace(/[\{\}\s]/g, '');
            const identifierNum = parseInt(identifier.replace(/[^0-9]/g, ''));
            const m = RegExp(`\{\{ +${identifier} +\}\}`);
            const possibleAnswers = question.answers.filter(a => a.dropDownIdentifier === identifierNum);
            const possibleAnswerIds = possibleAnswers.map(a => parseInt(a.id));
            const answerIds = state.answerIds;

            answerIds.forEach(id => {
              id = parseInt(id);
              if (possibleAnswerIds.includes(id)) {
                const answer = possibleAnswers.find(a => parseInt(a.id) === id);
                const replacementText = answer.content;
                questionText = questionText.replace(m, replacementText);
              }
            });
          });
        }
      }

      return questionText;
    },
  },
};
